"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.chunkArray = void 0;
var chunkArray = function(array, size) {
    if (size === 0) {
        return [
            array
        ];
    }
    var chunks = [];
    for(var i = 0; i < array.length; i += size){
        chunks.push(array.slice(i, i + size));
    }
    return chunks;
};
exports.chunkArray = chunkArray; //# sourceMappingURL=chunkArray.js.map
